import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import swapListSerialAndName from 'app/_shared/action/partial/swapListSerialAndName'
import displayFilters from 'app/_shared/action/partial/filter/display'
import setStatusFilter from 'app/_shared/action/partial/filter/setStatus'
import setTeamFilter from 'app/_shared/action/partial/filter/setTeam'
import setAssigneeFilter from 'app/_shared/action/partial/filter/setAssignee'
import setDateCreatedFilter from 'app/_shared/action/partial/filter/setDateCreated'
import setNotModifiedFilter from 'app/_shared/action/partial/filter/setNotModified'
import setSubmitterRoleFilter from 'app/_shared/action/partial/filter/setSubmitterRole'
import applyFilters from 'app/_shared/action/partial/filter/apply'

/**
 * Admin Tickets Action
 *
 * @param {Gaia.AppModule.Spec} module the admin module composition object
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayFilters(module),
  swapListSerialAndName(module),
  setStatusFilter(module)(component),
  setTeamFilter(module),
  setAssigneeFilter(module),
  setDateCreatedFilter(module),
  setNotModifiedFilter(module),
  setSubmitterRoleFilter(module),
  applyFilters(module),
)(find(component), ...args)
